export default function util() {
    const legendSort = () => {
        let prop = 'LegendSort';
        let discr = 'Discriminator';

        return function (a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            } else {
                if (a[discr] > b[discr]) {
                    return 1;
                } else if (a[discr] < b[discr]) {
                    return -1;
                } else return 0;
            }
        };
    };

    const drawSort = () => {
        let prop = 'DrawSort';
        let discr = 'Discriminator';

        return function (a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            } else {
                if (a[discr] < b[discr]) {
                    return 1;
                } else if (a[discr] > b[discr]) {
                    return -1;
                } else return 0;
            }
        };
    };

    const getSortOrder = (prop) => {
        return function (a, b) {
            if (a[prop] > b[prop]) {
                return -1;
            } else if (a[prop] < b[prop]) {
                return 1;
            } else {
                return 0;
            }
        };
    };

    const alphabeticSearch = (prop) => {
        return function (a, b) {
            let propA = a[prop] ? a[prop] : 0;
            let propB = b[prop] ? b[prop] : 0;

            if (propA > propB) {
                return 1;
            } else if (propA < propB) {
                return -1;
            } else {
                return 0;
            }
        };
    };

    return {
        getSortOrder: getSortOrder,
        drawSort: drawSort,
        legendSort: legendSort,
        alphabeticSearch: alphabeticSearch
    };
}
